import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DefaultDeliveryNoteModel, ShippingIcon } from '../../store/state/public-tracking';
import { IconNames, NOT_AVAILABLE, SHORT_DISPLAY_DATE_FORMAT } from '../../common/constants';
import { DeliveryDeviationModel, Deviation, DeviationType } from '../../store/models';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { InfoFieldItemComponent } from '../info-field/info-field-item/info-field-item.component';
import { DeviationTypeComponent } from '../deviation-type';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-delivery-status-tracking-main-info',
  imports: [
    CommonModule,
    IntrackFeatureModule,
    TranslateModule,
    InfoFieldItemComponent,
    DeviationTypeComponent,
    SvgIconComponent,
  ],
  templateUrl: './delivery-status-tracking-main-info.component.html',
  styleUrls: ['./delivery-status-tracking-main-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryStatusTrackingMainInfoComponent {
  @Input() overview: DefaultDeliveryNoteModel;

  notAvailable = NOT_AVAILABLE;
  dateFormat = SHORT_DISPLAY_DATE_FORMAT;
  type = DeviationType;
  shippingIcon = ShippingIcon;
  iconNames = IconNames;
  shippingIconList = {
    [ShippingIcon.Air]: IconNames.PlaneSide,
    [ShippingIcon.AirExpress]: IconNames.PlaneTop,
    [ShippingIcon.Store]: IconNames.Store,
    [ShippingIcon.Truck]: IconNames.TruckSizeL,
  };

  get deliveryDeviation(): Deviation {
    return new DeliveryDeviationModel(this.overview.deliveryDeviation);
  }

  get deliveryNoteNumber(): string {
    if (!this.overview) {
      return '';
    }

    const { deliveryNoteNumber, externalDeliveryNoteNumber } = this.overview;

    return deliveryNoteNumber === externalDeliveryNoteNumber ||
      externalDeliveryNoteNumber === null ||
      externalDeliveryNoteNumber === undefined
      ? deliveryNoteNumber
      : `${deliveryNoteNumber}/${externalDeliveryNoteNumber}`;
  }
}
